import React from "react";
import { useNavigate } from "react-router-dom";
import { TC_RADIUS } from "../../constants/templateCreatorConstants";

const PreApprovedTemplatesBanner = () => {
  const navigate = useNavigate();

  return (
    <div
      className={`border border-[#ccd0d5] ${TC_RADIUS} bg-white p-4 flex items-center gap-4 overflow-hidden`}
    >
      <div
        className="w-[120px] h-[88px] shrink-0 bg-gradient-to-br from-[#fff3cd] via-[#ffe8a3] to-[#ffd966] flex items-center justify-center"
        aria-hidden="true"
      >
        <div className="text-3xl leading-none select-none">📦</div>
      </div>
      <div className="flex-1 min-w-0">
        <h3 className="text-[15px] font-semibold text-[#050505] mb-1">
          Start with pre-approved templates
        </h3>
        <p className="text-[13px] text-[#65676b] leading-snug">
          Save time and get to market faster with pre-approved templates.
        </p>
      </div>
      <button
        type="button"
        onClick={() => navigate("/templates")}
        className={`shrink-0 px-4 py-2 text-[13px] font-semibold text-[#050505] bg-white border border-[#ccd0d5] hover:bg-[#f0f2f5] transition-colors ${TC_RADIUS}`}
      >
        Go to template library
      </button>
    </div>
  );
};

export default PreApprovedTemplatesBanner;
